import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getErrorObjFormat } from "../../../helpers/errorObjFormat";

const baseUrl = process.env.REACT_APP_API_BASE_URL + "/v1/payment-accounts";

const initialState = {
  accountsList: [],
  isLoading: false,
  isCreating: false,
  error: null,
  errorCreate: null,
};

const paymentAccounts = createSlice({
  name: "paymentAccounts",
  initialState,
  reducers: {
    fetchAccountsStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchAccountsSuccess(state, { payload }) {
      state.accountsList = payload;
      state.isLoading = false;
    },
    fetchAccountsFailure(state, { payload }) {
      state.isLoading = false;
      state.error = payload;
    },
    createAccountStart(state) {
      state.isCreating = true;
      state.errorCreate = null;
    },
    createAccountSuccess(state, { payload }) {
      state.isCreating = false;
      state.accountsList = [...state.accountsList, payload];
    },
    createAccountFailure(state, { payload }) {
      state.isCreating = false;
      state.errorCreate = payload;
    },
    clearErrorCreate(state) {
      state.errorCreate = null;
    },
    deleteAccountStart(state) {
      state.isDeleting = true;
      state.errorDelete = null;
    },
    deleteAccountSuccess(state, { payload }) {
      state.isDeleting = false;
      state.accountsList = state.accountsList.filter(
        (a) => a.account_id !== payload
      );
    },
    deleteAccountFailure(state, { payload }) {
      state.isDeleting = false;
      state.errorDelete = payload;
    },
  },
});

export const {
  fetchAccountsStart,
  fetchAccountsSuccess,
  fetchAccountsFailure,
  createAccountStart,
  createAccountSuccess,
  createAccountFailure,
  clearErrorCreate,
  deleteAccountStart,
  deleteAccountSuccess,
  deleteAccountFailure,
} = paymentAccounts.actions;

export default paymentAccounts.reducer;

export const fetchPaymentAccounts =
  ({ hotelId, condoId } = {}) =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchAccountsStart());
      const params = condoId ? { condo_id: condoId } : { hotel_id: hotelId };
      const res = await axios.get(baseUrl, {
        params,
        headers: { Authorization: `Bearer ${getState().auth.token}` },
      });
      dispatch(fetchAccountsSuccess(res.data.response));
    } catch (err) {
      dispatch(fetchAccountsFailure(getErrorObjFormat(err)));
    }
  };

export const deletePaymentAccount =
  (accountId) => async (dispatch, getState) => {
    try {
      dispatch(deleteAccountStart());
      await axios.delete(`${baseUrl}/${accountId}`, {
        headers: { Authorization: `Bearer ${getState().auth.token}` },
      });
      dispatch(deleteAccountSuccess(accountId));
      return { error: false };
    } catch (err) {
      const errorObj = getErrorObjFormat(err);
      dispatch(deleteAccountFailure(errorObj));
      return { error: true, ...errorObj };
    }
  };

export const createPaymentAccount =
  (accountObj) => async (dispatch, getState) => {
    try {
      dispatch(createAccountStart());
      const res = await axios.post(baseUrl, accountObj, {
        headers: { Authorization: `Bearer ${getState().auth.token}` },
      });
      dispatch(createAccountSuccess(res.data.response));
      return { error: false, data: res.data.response };
    } catch (err) {
      const errorObj = getErrorObjFormat(err);
      dispatch(createAccountFailure(errorObj));
      return { error: true, ...errorObj };
    }
  };
